import { TextV2, styled } from '@shared/joykit/packages';

/**
 * One value-prop row. A highlighted row owns its own text and divider colors, so the tinted group
 * around it never has to out-rank this rule in the cascade.
 */
export const ValuePropLineItem = styled(TextV2)<{ $highlight?: boolean }>`
  padding-top: 0.5rem;
  color: ${props => (props.$highlight ? props.theme.colors.mono14 : props.theme.colors.mono12)};
  &:not(&:first-of-type) {
    border-top: 1px solid ${props => (props.$highlight ? props.theme.colors.positive3 : props.theme.colors.mono3)};
  }
`;

/**
 * Tinted group for the value props that set an option apart (SMS and WhatsApp on Text & Email).
 * The negative horizontal margin bleeds the tint into the card padding, so the row text stays
 * aligned with the rows above. Row colors live on `ValuePropLineItem` via `$highlight`.
 */
export const HighlightedValuePropGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${props => props.theme.space[3]};
  margin: 0 -${props => props.theme.space[4]};
  padding: 0 ${props => props.theme.space[4]} ${props => props.theme.space[3]};
  border-radius: ${props => props.theme.radii[3]};
  background-color: ${props => props.theme.colors.positive2};
`;
